enum PriceWeightUnitEnum {
  KG = 1,
  TONN = 2,
  METER = 3,
  STK = 4,
  M3 = 5,
}

export default PriceWeightUnitEnum;
